import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './components/pages/Home';
import TermsConditions from './components/pages/TermsConditions';

import NotFound from './components/common/NotFound';
import './App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<TermsConditions />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;